import axios from "axios";
import keyEventHandler from "./keyEventHandler";

Array.from(document.querySelectorAll('.search-listing-wrapper')).forEach(function(wrapper) {
    
    let input = wrapper.querySelector('[data-search-endpoint]');
    let endpoint = input.getAttribute('data-search-endpoint');
    let list = wrapper.querySelector('.search-listing-values');
    let key = list.getAttribute('data-search-listing-key');
    let valueInput = wrapper.querySelector('[name="' + key + '"]');

    let suggestionBox = document.createElement('div');
    suggestionBox.classList.add('search-listing-suggestions');
    suggestionBox.setAttribute('data-search-listing-key', key);

    let suggestionContainer = document.createElement('div');
    suggestionContainer.className = 'search-listing-suggestion-container';
    suggestionBox.appendChild(suggestionContainer);

    let suggestionsList = document.createElement('div');
    suggestionsList.className = 'search-listing-suggestion-list';
    suggestionContainer.appendChild(suggestionsList);

    document.body.appendChild(suggestionBox);

    if (valueInput.value.trim().length && valueInput.value.trim() != '[]') {

        axios.get(endpoint + '?current=' + valueInput.value.trim()).then(function(response) {

            let data = response.data;

            let keys = Object.keys(data);

            for (let i = 0; i < keys.length; i++) {
                list.innerHTML += _buildAddedSuggestion(keys[i], data[keys[i]]);
            }

        }).catch(function(err) {

            console.log("err");
            console.error(err);
            console.error(err.message);

        });

    }

    input.oninput = function(e) {

        let val = this.value.trim();

        if (val.length >= 1) {

            axios.get(endpoint + '?query=' + val).then(function(response) {

                let data = response.data;

                suggestionsList.innerHTML = _buildSuggestions(data);
                _displaySuggestions(suggestionBox, input);
                positionTo(suggestionBox, input, false, true);


            }).catch(function(err) {

                console.log("err");
                console.error(err);
                console.error(err.message);

            });

        } else {
            _dismissSuggestions(suggestionBox, input);
        }

    }

    input.addEventListener('keydown', function(event) {
        let key = keyEventHandler(event);

        if (key.key == 'Escape') {
            _dismissSuggestions(suggestionBox, input);
        }
    });

    suggestionBox.onfocusout = function(event) {
        if (!event.relatedTarget || (event.relatedTarget && event.relatedTarget.closest('.form-control') !== input)) {
            _dismissSuggestions(suggestionBox);
            // optionsElement.classList.remove('actions--active');
            // actionButton.classList.remove('button--active');
        }
    }

    suggestionBox.onclick = function(event) {
        let suggestion = event.target.closest('.search-listing-suggestion-list-item');

        if (suggestion) {
            let value = suggestion.getAttribute('data-value');
            let label = suggestion.getAttribute('data-label');

            _addSuggestion(value, label, list, valueInput);
            _dismissSuggestions(suggestionBox, input);
        }

    }

    list.onclick = function(event) {
        let addedSuggestion = event.target.closest('.search-listing-suggestion-added');

        if (addedSuggestion) {

            let value = addedSuggestion.getAttribute('data-value');

            _removeSuggestion(value, list, valueInput);
        }
    }


});

function _displaySuggestions(box, input) {    
    box.style.display = 'block';
    positionTo(box, input, false, true);
}

function _dismissSuggestions(box, input) {
    
    box.style.display = 'none';
    box.querySelector('.search-listing-suggestion-list').innerHTML = '';

    if (input) {
        input.value = '';
    }

}

function _buildSuggestions(data) {
    let output = '';

    let keys = Object.keys(data);

    for (let i = 0; i < keys.length; i++) {
        output += _buildSuggestion(keys[i], data[keys[i]]);
    }

    return output;
}

function _buildSuggestion(value, label) {
    return `<div class="search-listing-suggestion-list-item" data-value="${value}" data-label="${label}" tabindex="0">
                <p class="search-listing-suggestion-title">${label}</p>
            </div>`;
}

function _addSuggestion(value, label, list, valueInput) {

    let values = JSON.parse(valueInput.value);

    if (values.indexOf(value) === -1) {
        values.push(value);
        valueInput.value = JSON.stringify(values);

        list.innerHTML += _buildAddedSuggestion(value, label);
    }

}

function _removeSuggestion(value, list, valueInput) {
    let values = JSON.parse(valueInput.value);

    values = values.filter(function(_) {
        return value != _
    });

    valueInput.value = JSON.stringify(values);

    let button = list.querySelector('[data-value="' + value + '"]');
    if (button) {
        button.remove();
    }
}

function _buildAddedSuggestion(value, label) {
    return `<button class="button button--small button--white button--outline filter-button search-listing-suggestion-added" data-value="${value}">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M0 24L24 0M0 0l24 24"></path></svg>
                <span class="fw-600 color-black">${label}</span>
            </button>`;
}


function positionTo(source, target, offset, matchTargetWidth) {

    offset = offset || false;
    matchTargetWidth = matchTargetWidth || false;

    if (!offset) {
        offset = {
            x: 0,
            y: 0,
        };
    } else if(parseFloat(offset)) {
      let xy = parseFloat(offset);
      offset = {
          x: xy,
          y: xy,
      };
    } else {
        offset = {
            x: offset.x || 0,
            y: offset.y || 0
        };
    }

    let yOffset = window.yOffset || (document.documentElement.clientHeight) ? document.documentElement.scrollTop : document.body.scrollTop;

    let targetRect = target.getBoundingClientRect();

    if (matchTargetWidth) {
        source.style.width = targetRect.width + "px";
    }

    let sourceRect = source.getBoundingClientRect();
    
    let newY = 10 + yOffset + targetRect.y + targetRect.height + offset.y;
    let newX = (targetRect.x + targetRect.width) - (sourceRect.width + offset.x);   

    if (newY + sourceRect.height >= yOffset + document.documentElement.clientHeight) {
        newY = yOffset + (targetRect.y - sourceRect.height - 10 - offset.y);
    }
    

    source.style.left = newX + "px";
    source.style.top = newY + "px";

}